import { render, staticRenderFns } from "./AccountUiIcon.vue?vue&type=template&id=55e01682&scoped=true"
import script from "./AccountUiIcon.vue?vue&type=script&lang=js"
export * from "./AccountUiIcon.vue?vue&type=script&lang=js"
import style0 from "./AccountUiIcon.vue?vue&type=style&index=0&id=55e01682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e01682",
  null
  
)

export default component.exports